import { useDraggable } from "@dnd-kit/core";
import { Box, Grid } from "@mui/material";
import { GripVertical } from "lucide-react";
import AssetCard from "./AssetCard";

const DraggableAssetCard = ({ asset }) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: asset.id,
    data: { asset },
  });

  return (
    <Grid
      size={{ md: 4, xs: 12 }}
      ref={setNodeRef}
      style={{ opacity: isDragging ? 0.4 : 1 }}
    >
      <Box sx={{ position: "relative" }}>
        <Box
          {...attributes}
          {...listeners}
          sx={{
            position: "absolute",
            top: 8,
            left: 8,
            zIndex: 10,
            cursor: "grab",
            backgroundColor: "background.paper",
            borderRadius: 1,
            p: 0.5,
            display: "flex",
            alignItems: "center",
            boxShadow: 1,
            opacity: 0.7,
            "&:hover": { opacity: 1 },
            "&:active": { cursor: "grabbing" },
          }}
        >
          <GripVertical size={14} />
        </Box>
        <AssetCard asset={asset} isWrapped />
      </Box>
    </Grid>
  );
};

export default DraggableAssetCard;
